import { USER_SIGN_IN_SUCCESS} from "Store/constants";

function doUpdateFileSelectorController(component, emitter, mountedCallback, onClickCallback) {
  let _this = component;
  function addListener(event, handler) {
    emitter.on(event, handler);
    return () => {
      emitter.removeListener(event, handler);
    };
  }
  const onClick = (e) => {
    onClickCallback && onClickCallback(_this, e);
  };

  const disableClick = (e) =>{
    e && e.preventDefault();
  }

  _this.doEnableNoticeClick = () => {
    //_this.inputElement.setAttribute('disabled', 'disabled');
    //_this.inputElement.classList.add('disabled')
    console.log(_this.inputElement)
    console.log(_this.labelElement)
    _this.inputElement.addEventListener('click', disableClick);

    _this.labelElement.addEventListener('click', onClick);
    _this.addDestroyHook(() => {
      _this.inputElement.removeEventListener('click', disableClick);
      _this.labelElement.removeEventListener('click', onClick);
    });
  }
  _this.doEnableInput = () =>{
    //_this.inputElement.classList.remove('disabled')
    //_this.inputElement.removeAttribute('disabled');
    _this.inputElement && _this.inputElement.removeEventListener('click', disableClick);
    _this.labelElement && _this.labelElement.removeEventListener('click', onClick);
  }

  // do
  _this.addDestroyHook(
    addListener(USER_SIGN_IN_SUCCESS, () => {
      mountedCallback && mountedCallback(_this);
    }),
  );
  mountedCallback && mountedCallback(_this);
}

export {
  doUpdateFileSelectorController
}